import {twMerge} from 'tailwind-merge';

interface Props {
    checked: boolean;
    onChange: (checked: boolean) => void;
    description?: string;
    disabled?: boolean;
    label?: string;
    className?: string;
}

export const Checkbox = ({checked, onChange, description, disabled, label, className}: Props) => {
    return (
        <label
            className={twMerge(
                'ml-2 flex items-center justify-center gap-2 text-ellipsis text-xs font-medium text-gray-900',
                className
            )}
        >
            <input
                type="checkbox"
                checked={checked}
                onChange={() => onChange(!checked)}
                className="h-4 w-4 rounded-3xl border-gray-300 bg-gray-100 text-blue-600 dark:border-gray-600 dark:bg-gray-700 dark:ring-offset-gray-800 dark:focus:ring-blue-600"
            />
            {label}
        </label>
    );
};
